import BlogListing from 'components/BlogPost/BlogListing';
import NewsListing from 'components/BlogPost/NewsListing';
import CaseListingHero from 'components/CaseStudy/CaseListingHero';
import Legals from 'components/Legals/Legals';
import PodcastListing from 'components/PodcastPost/PodcastPostListing';
import ResourceLandingPage from 'components/Resources/ResourceLandingPage';
import BodySplit from 'components/SingleInstance/BodySplit';
import ImageBanner from 'components/SingleInstance/ImageBanner';
import JobBoard from 'components/SingleInstance/JobBoard';
import MerchantPortal from 'components/SingleInstance/MerchantPortal';
import ResourceHub from 'components/SingleInstance/ResourceHub';
import TemplateHub from 'components/SingleInstance/TemplateHub';
import Slider from 'components/Slider/Slider';
import WebinarListing from 'components/Webinar/Listing';

import type { ContentfulComponentSingleInstance } from 'graphqlTypes';
import type { FC } from 'react';

interface ComponentSingleInstanceProps extends ContentfulComponentSingleInstance {
  backgroundIsDark: boolean;
}

const SingleInstance: FC<ComponentSingleInstanceProps> = ({ component, backgroundIsDark, ...props }) => {
  switch (component) {
    case 'Case Study Listing':
    case 'Report Listing':
    case 'Infographics Listing':
    case 'Eguide Listing':
    case 'Tips and Tool Listing':
    case 'Video Listing':
    case 'Video Webinar Listing':
      return (
        <ResourceLandingPage
          backgroundIsDark={backgroundIsDark}
          {...(component === 'Video Listing' ? { isVideo: true } : {})}
          {...props}
        />
      );
    case 'Webinar Listing':
      return <WebinarListing backgroundIsDark={backgroundIsDark} {...props} />;
    case 'Blog Listing':
      return <BlogListing backgroundIsDark={backgroundIsDark} {...props} />;
    case 'News Listing':
      return <NewsListing backgroundIsDark={backgroundIsDark} {...props} />;
    case 'Case Study Hero':
      return <CaseListingHero backgroundIsDark={backgroundIsDark} {...props} />;
    case 'Legal':
      return <Legals {...props} />;
    case 'Careers Listing':
      return <JobBoard {...props} />;
    case 'Resource Hub':
      return <ResourceHub backgroundIsDark={backgroundIsDark} {...props} />;
    case 'Template Hub':
      return <TemplateHub backgroundIsDark={backgroundIsDark} {...props} />;
    case 'Slider':
      return <Slider backgroundIsDark={backgroundIsDark} {...props} />;
    case 'Podcast Listing':
      return <PodcastListing backgroundIsDark={backgroundIsDark} {...props} />;
    case 'Merchant Portal':
      return <MerchantPortal {...props} />;
    case 'Body Split':
      return <BodySplit backgroundIsDark={backgroundIsDark} {...props} />;
    case 'Image Banner':
      return <ImageBanner {...props} />;
    default:
      return null;
  }
};

export default SingleInstance;
